/* Установщик «Инфографика»: объект в window на том месте порядка скриптов, где стоял assets/bot-infog.js.
   В серверном режиме движок шаблона получает сервер экрана (infog-server.ts) и экран infog встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createInfog } from './engine';
import { createInfogServer, registerInfogEngine } from './infog-server';

export function installInfog() {
  const server = isServerMode();
  createInfog(server ? createInfogServer : null);
  if (server) registerInfogEngine();
}
